import { Component, EventEmitter, Input, Output } from "@angular/core";
import { LucideAngularModule, Menu } from "lucide-angular";
import { EnvironmentIndicatorComponent } from "../../environment-indicator/environment-indicator.component";

@Component({
  selector: "app-mobile-header",
  standalone: true,
  imports: [LucideAngularModule, EnvironmentIndicatorComponent],
  template: `
    <div
      class="md:hidden p-3 border-b border-light-border dark:border-dark-border flex items-center gap-3"
    >
      <button
        (click)="toggleMenu.emit()"
        class="p-1.5 rounded-lg hover:bg-light-bg-secondary dark:hover:bg-dark-surface-variant"
      >
        <lucide-angular [img]="Menu" class="w-5 h-5"></lucide-angular>
      </button>
      <div class="flex-1 min-w-0">
      </div>
      <div class="flex-shrink-0">
        <app-environment-indicator></app-environment-indicator>
      </div>
    </div>
  `,
  styles: [],
})
export class MobileHeaderComponent {
  // Icons
  readonly Menu = Menu;

  @Input() currentPage: string | null = "Home"; // Allow null and provide a default value
  @Output() toggleMenu = new EventEmitter<void>();
}
